// Presentation acknowledgements are separate from authoritative cart validation.
export const cartChangeNoticeKey = (line, group, context = {}) => JSON.stringify([
  context.type, context.countryId, context.areaId, context.branchId, context.branchDeliveryChargeId,
  context.time?.type, context.time?.type === "scheduled" ? [context.time.date, context.time.start, context.time.end] : null,
  group, String(line.lineId), line.reason, line.originalQuantity, line.quantity,
]);

export const visibleCartChanges = (classification, dismissed = [], context = {}) => {
  const hidden = new Set(dismissed);
  const adjusted = classification.adjusted || [];
  return {
    retained: [...(classification.retained || []), ...adjusted.filter(line => hidden.has(cartChangeNoticeKey(line, "adjusted", context))).map(line => ({ ...line, reason: null }))],
    adjusted: adjusted.filter(line => !hidden.has(cartChangeNoticeKey(line, "adjusted", context))),
    removed: (classification.removed || []).filter(line => !hidden.has(cartChangeNoticeKey(line, "removed", context))),
  };
};

export const cartChangeSummary = (removed, adjusted, arabic = false) => [
  removed > 0 ? arabic ? `سيتم استبعاد ${removed} من المنتجات` : `${removed} ${removed === 1 ? "item" : "items"} will be removed` : null,
  adjusted > 0 ? arabic ? `سيتم تعديل كمية ${adjusted} من المنتجات` : `Quantity will change for ${adjusted} ${adjusted === 1 ? "item" : "items"}` : null,
].filter(Boolean).join(arabic ? "، " : ". ");
